import { Component, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
    standalone: false,
    selector: 'app-team-popover',
    templateUrl: './team-popover.component.html',
    styleUrls: ['./team-popover.component.scss'],
})
export class TeamPopoverComponent {

    @Input() canFollow: boolean;
    @Input() isOwner: boolean;

    constructor(
        private popoverController: PopoverController
    ) { }

    dismiss(type) {
        this.popoverController.dismiss(type);
    }

}
